import { rule, messages } from 'vue-mc/validation';

const skipValidation = rule({
	name: 'skipValidation',
	test: (value, propName, model) => model.skipValidation,
});

messages.set('skipValidation', 'skipValidation must be used with OR');

export default skipValidation;
